import { Space } from 'antd';
import React from 'react';
import styled from 'styled-components';

import SelectionCheckbox from './SelectionCheckbox';
import SelectionMenu from './SelectionMenu';

const Container = styled(Space.Compact)`
  display: flex;
`;

function SelectionGroup() {
  return (
    <Container>
      <SelectionCheckbox />
      <SelectionMenu />
    </Container>
  );
}

export default SelectionGroup;
